import React from "react";
import { Navigate, Outlet } from "react-router";

const PrivateRoute = () => {
  const token = sessionStorage.getItem("userToken");
  //   console.log("token - ", token);
  return token ? <Outlet /> : <Navigate to="/auth" replace />;
};

export default PrivateRoute;
